import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Permissions from 'javascripts/analytics/config/permissions';
import { useSurfaces } from 'js/analytics/autotest/AutotestAnalytics';

export const NoDataTab = ({
  title,
  details,
  loggedOutTitle,
  noUploadButton,
  customUploadButton,
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // Autotest empty-state copy slot (default null => original per-tab title).
  const { emptyStateCopy } = useSurfaces();
  const ownerTitle = emptyStateCopy || title;

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderMessage = () => {
    if (Permissions.isOwner) {
      return (
        <div>
          <h1 className="u-mb5x">{ownerTitle}</h1>
          {/* NATIONAL PARKS: Please remove this disable and try to fix it if you're here */}
          {/* eslint-disable-next-line react/no-danger */}
          <h4 dangerouslySetInnerHTML={{ __html: details }}></h4>
          {renderUploadButton()}
        </div>
      );
    } else {
      return <h1>{loggedOutTitle || "There's no data here yet."}</h1>;
    }
  };

  const renderUploadButton = () => {
    if (noUploadButton) {
      return null;
    }
    if (customUploadButton) {
      return customUploadButton;
    }
    return (
      <a
        className="btn btn-default btn-success btn-academia-green btn-lg upload-paper-button u-mt5x"
        href={'https://' + $app_host + '/upload-a-paper/analytics_empty_tab'}
      >
        Upload a Paper
      </a>
    );
  };

  return (
    <div className="panel panel-flat u-taCenter a-fadeInDown">
      <div className="panel-body u-p12x u-tcGrayDarkest">
        {windowWidth >= 1000 && (
          <img
            src={$image_url('icons/big-stats.png')}
            alt=""
            width="851"
            height="83"
          />
        )}
        {renderMessage()}
      </div>
    </div>
  );
};

NoDataTab.propTypes = {
  title: PropTypes.string,
  details: PropTypes.string,
  loggedOutTitle: PropTypes.string,
  noUploadButton: PropTypes.bool,
  customUploadButton: PropTypes.node,
};
